module.exports = __webpack_public_path__ + "hyperion-v2-static/img/resources_country_report.c5406dbf.png";